import React, { useState, useRef } from "react";
import axios from "axios";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import emailjs from '@emailjs/browser';

import "./App.css";

const ReservationForm = () => {
  const form = useRef();

  // EmailJS Configuration Variables
  const SERVICE_ID = "service_81tsk46";
  const TEMPLATE_ID = "template_eu7wec1";
  const USER_ID = "xTO7fyT-GZuWL8lwM"; // Use your actual user ID

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    functionDate: "",
    event: "",
    specialNote: ""
  });

  const [errors, setErrors] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handle phone number change
  const handlePhoneChange = (e) => {
    setFormData(prevState => ({
      ...prevState,
      phone: e.target.value
    }));
  };

  // Validate the form fields
  const validateForm = () => {
    let tempErrors = {};

    if (!formData.name.trim()) {
      tempErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
    }

    if (!formData.phone.trim()) {
      tempErrors.phone = "Phone number is required";
    }

    if (!formData.functionDate) {
      tempErrors.functionDate = "Function date is required";
    }

    if (!formData.event) {
      tempErrors.event = "Event is required";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Send email using EmailJS
  const sendEmail = (e) => {
    e.preventDefault();

    // Validate form before sending
    if (!validateForm()) {
      return;
    }

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID)
      .then(() => {
        setOpenSuccessDialog(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          functionDate: "",
          event: "",
          specialNote: ""
        });
      }, (error) => {
        console.error("Email sending error:", error);
      });
  };

  // Close dialogs
  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
  };

  return (
    <div className="reservation-form-container">
      <h2>Contact Us For Your Reservation</h2>
      <form ref={form} onSubmit={sendEmail}>
        {/* Name and Email in same row */}
        <div className="row">
          <div className="inputGroup">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="input"
              placeholder="Name"
              required
            />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div className="inputGroup">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="input"
              placeholder="Email"
              required
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
        </div>

        {/* Phone number */}


        {/* Date and Event selection in same row */}
        <div className="row">
        <div className="inputGroup">
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handlePhoneChange}
                      className="input"
                      placeholder="Phone Number"
                      required
                    />
                    {errors.phone && <span className="error">{errors.phone}</span>}
                  </div>
          <div className="inputGroup">
            <input
              type="date"
              name="functionDate"
              value={formData.functionDate}
              onChange={handleChange}
              className="input"
              required
            />
            {errors.functionDate && <span className="error">{errors.functionDate}</span>}
          </div>
          <div className="inputGroup">
            <select
              name="event"
              value={formData.event}
              onChange={handleChange}
              className="input"
              required
            >
              <option value="">Select an event</option>
              <option value="Wedding Event">Wedding Event</option>
              <option value="Birthday Event">Birthday Event</option>
              <option value="Special Event">Special Event</option>
              <option value="Auvrudhu Event">Auvrudhu Event</option>
              <option value="Spend The Day - Morning">Spend The Day - Morning</option>
              <option value="Spend The Day - Evening">Spend The Day - Evening</option>
              <option value="Co-operate Event">Co-operate Event</option>
              <option value="Photo Shoot">Photo Shoot</option>
              <option value="Accommodation">Accommodation</option>
            </select>
            {errors.event && <span className="error">{errors.event}</span>}
          </div>
        </div>

        {/* Special Note */}
        <div className="inputGroup">
          <textarea
            name="specialNote"
            value={formData.specialNote}
            onChange={handleChange}
            placeholder="Special Note"
          />
        </div>

        {/* Consent Paragraph */}
        <p className="consent-paragraph">
          By giving your confirmation you explicitly give consent for us to store and use this information to service your requests.
          If you do not consent we will not store any personal information and will only send an email with the relevant details in order to service your requests.
        </p>

        <button type="submit" className="res-button" value="Send">Submit</button>
      </form>

      {/* Confirmation Dialog */}
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog} aria-labelledby="confirmation-dialog-title" aria-describedby="confirmation-dialog-description">
        <DialogTitle id="confirmation-dialog-title">Confirm Reservation</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmation-dialog-description">
            Are you sure you want to proceed with this reservation?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmDialog} color="secondary">No</Button>
          <Button onClick={sendEmail} color="primary" autoFocus>Yes</Button>
        </DialogActions>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={openSuccessDialog} onClose={handleCloseSuccessDialog} aria-labelledby="success-dialog-title" aria-describedby="success-dialog-description">
        <DialogTitle id="success-dialog-title">Reservation Successful</DialogTitle>
        <DialogContent>
          <DialogContentText id="success-dialog-description">
            Your reservation was successful! We will inform you of further details through the email you provided.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSuccessDialog} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ReservationForm;
